import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthProvider, useAuth } from '@/lib/auth';
import { Layout } from '@/components/Layout';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { UsersPage } from '@/pages/UsersPage';
import { PointsPage } from '@/pages/PointsPage';
import { ResearchPage } from '@/pages/ResearchPage';
import { FeedbackPage } from '@/pages/FeedbackPage';

function Protected() {
  const { t } = useTranslation();
  const { user, loading } = useAuth();
  if (loading) {
    return <p className="p-8 text-sm text-stone-500">{t('common.loading')}</p>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<Protected />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/points" element={<PointsPage />} />
            <Route path="/research" element={<ResearchPage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
